// extracted by mini-css-extract-plugin
export default {"deleteSlider":"deleteStream_deleteSlider__K5paT","details":"deleteStream_details__OgXej","image":"deleteStream_image__IBKsb"};